import request from "@/axios/request";
import myJsTools from "../utils/myJsTools";

const user = {};

/**
 * 获取临床诊断列表
 */
export function findByName(data) {
  return request({
    url: "dictionary/dicdiagnosis/findAll",
    method: "post",
    data: data
  });
}

/**
 * 获取临床诊断列表分页
 */
export function findAllListPage(data) {
  return request({
    url: "dictionary/dicdiagnosis/findAllListPage",
    method: "post",
    data: data
  });
}

/**
 * 获取检验检查诊断列表分页
 */
export function getPacsLisDiagnosisList(data) {
  return request({
    url: "dictionary/dicdiagnosis/getPacsLisDiagnosisList",
    method: "post",
    data: data
  });
}
/**
 * 查询草药特殊煎法
 */
export function getDicDrugDecoction(data) {
  return request({
    url: "dictionary/dicdrugdecoction/getDicDrugDecoction",
    method: "post",
    data: data
  });
}

/**
 * 查询全部药品，收藏标志
 */
export function findAllDrug(data) {
  return request({
    url: "basic/dicDrugController/drugPageList",
    method: "post",
    data: data
  });
}

/**
 * 查询药品详情
 */
export function findDrugById(data) {
  return request({
    url: "/basic/dicDrugController/findDrugById",
    method: "post",
    data: data
  });
}

/**
 * 查询全部西药品，收藏标志
 */
export function findAllDrugNoPage(data) {
  return request({
    url: "basic/dicDrugController/findAllDrugNoPage",
    method: "post",
    data: data
  });
}

/**
 * 获取频次
 */
export function findAll(data) {
  return request({
    url: "basic/dicdrugfrequency/findAll",
    method: "post",
    data: data
  });
}

/**
 * 服用方法
 */
export function dicdrugusage(data) {
  return request({
    url: "basic/dicdrugusage/findAll",
    method: "post",
    data: data
  });
}

/**
 * 保存处方
 */
export function savePrescription(data) {
  return request({
    url: "business/proPrescriptionController/savePrescription",
    method: "post",
    data: data
  });
}

/**
 * 患者获取处方信息
 */
export function getPatientPrescriptionInfo(data) {
  return request({
    url: "business/proPrescriptionController/getPatientPrescriptionInfo",
    method: "post",
    data: data,
    headers: {
      hosId: myJsTools.getItem("hosId")
    }
  });
}

/**
 * 删除医生诊疗笔记
 */
export function deleteDocMedicalRecordById(data) {
  return request({
    url: "business/docmedicalrecord/deleteDocMedicalRecordById",
    method: "post",
    data: data
  });
}

/**
 * 获取医生诊疗笔记详情
 */
export function getDocMedicalRecordById(data) {
  return request({
    url: "business/docmedicalrecord/getDocMedicalRecordById",
    method: "post",
    data: data
  });
}

/**
 * 添加收藏常用药
 */
export function addDoccommondrug(data) {
  return request({
    url: "basic/doccommondrug/add",
    method: "post",
    data: data
  });
}

/**
 * 添加收藏常用药
 */
export function cancelDoccommondrug(data) {
  return request({
    url: "basic/doccommondrug/cancel",
    method: "post",
    data: data
  });
}

/**
 * 医生app 查医生常用药
 */
export function findDrugByDocId(data) {
  return request({
    url: "basic/dicDrugController/findDrugByDocId",
    method: "post",
    data: data
  });
}

/**
 * 医生app 查询医生常用处方
 */
export function findDocCommonPrescription(data) {
  return request({
    url: "basic/doccommonprescription/findDocCommonPrescription",
    method: "post",
    data: data
  });
}

/**
 * 医生app 查询医生常用处方详情
 */
export function findDocCommonPrescriptionDetail(data) {
  return request({
    url: "basic/doccommonprescription/findDocCommonPrescriptionDetail",
    method: "post",
    data: data
  });
}

/**
 * 医生app 查询医生关联药店列表
 */
export function getDoctorLinkDrugstoreList(data) {
  return request({
    url: "basic/doctor/getDoctorLinkDrugstoreList",
    method: "post",
    data: data
  });
}

/**
 * 查询患者的历史处方
 */
export function findDocPrescriptionHistory(data) {
  return request({
    url: "business/proPrescriptionController/findDocPrescriptionHistory",
    method: "post",
    data: data
  });
}

/**
 * 查询历史处方明细
 */
export function findPatientPrescriptionHistoryDetail(data) {
  return request({
    url:
      "business/proPrescriptionController/findPatientPrescriptionHistoryDetail",
    method: "post",
    data: data
  });
}

/**
 * 添加常用处方
 */
export function addDoccommonprescription(data) {
  return request({
    url: "basic/doccommonprescription/edit",
    method: "post",
    data: data
  });
}

/**
 * 删除常用处方
 */
export function deleteDoccommonprescription(data) {
  return request({
    url: "basic/doccommonprescription/delete",
    method: "post",
    data: data
  });
}

/**
 * 验证药品库存是否满足
 */
export function checkDrugStorage(data) {
  return request({
    url: "basic/dicDrugController/checkDrugStorage",
    method: "post",
    data: data
  });
}

/**
 * 根据ID获取处方卡片明细信息
 */
export function getPrescriptionCardDetailInfo(data) {
  return request({
    url: "business/proPrescriptionController/getPrescriptionCardDetailInfo",
    method: "post",
    data: data,
    headers: {
      hosId: myJsTools.getItem("hosId")
    }
  });
}

/**
 * 根据ID获取处方卡片信息
 */
export function getPrescriptionCardInfo(data) {
  return request({
    url: "business/proPrescriptionController/getPrescriptionCardInfo",
    method: "post",
    data: data
  });
}

/**
 * 查询医生的历史处方
 */
export function findDocPrescriptionhistory(data) {
  return request({
    url: "business/proPrescriptionController/findDocPrescriptionhistory",
    method: "post",
    data: data
  });
}

/**
 * 查询处方订单清单
 */
export function getPrescriptionOrderList(data) {
  return request({
    url: "business/proPrescriptionController/getPrescriptionOrderList",
    method: "post",
    data: data
  });
}

/**
 * 根据ID获取处方业务信息
 */
export function getPrescriptionInfoById(data) {
  return request({
    url: "business/proPrescriptionController/getPrescriptionInfoById",
    method: "post",
    data: data,
    headers: {
      hosId: myJsTools.getItem("hosId")
    }
  });
}

/**
 * 根据ID获取处方订单信息
 */
export function getPatientPrescriptionOrderInfoById(data) {
  return request({
    url:
      "business/proPrescriptionController/getPatientPrescriptionOrderInfoById",
    method: "post",
    data: data,
    headers: {
      hosId: myJsTools.getItem("hosId")
    }
  });
}

/**
 * 查询医生药品费用统计
 */
export function getDocDrugCostStatistics(data) {
  return request({
    url: "business/prescriptionStatisticsController/getDocDrugCostStatistics",
    method: "post",
    data: data
  });
}

/**
 * 查询医生处方和订单费用统计
 */
export function getDocPreAndOrderStatistics(data) {
  return request({
    url:
      "business/prescriptionStatisticsController/getDocPreAndOrderStatistics",
    method: "post",
    data: data
  });
}

/**
 * 修改诊断业务状态
 */
export function updateBussStatus(data) {
  return request({
    url: "business/proPrescriptionController/updateBussStatus",
    method: "post",
    data: data,
    headers: {
      hosId: myJsTools.getItem("hosId")
    },
    loading: true,
  });
}

/**
 * 获取不同状态下审核处方的数量
 */
export function getCheckPrescriptionStatusNum(data) {
  return request({
    url: "business/proCheckPrescription/getCheckPrescriptionStatusNum",
    method: "post",
    data: data
  });
}

/**
 *
 保存医生诊疗笔记
 */
export function saveDocMedicalRecord(data) {
  return request({
    url: "business/docmedicalrecord/saveDocMedicalRecord",
    method: "post",
    data: data
  });
}

/**
 * 获取待审方列表
 */
export function getNotCheckPrescriptionList(data) {
  return request({
    url: "business/proCheckPrescription/getNotCheckPrescriptionList",
    method: "post",
    data: data
  });
}

/**
 * 获取未通过审核的处方详情
 */
export function getNotPassCheckPrescriptionInfo(data) {
  return request({
    url: "business/proCheckPrescription/getNotPassCheckPrescriptionInfo",
    method: "post",
    data: data,
    headers: {
      hosId: myJsTools.getItem("hosId")
    }
  });
}

/**
 * 获取审方列表
 */
export function getCheckPrescriptionList(data) {
  return request({
    url: "business/proCheckPrescription/getCheckPrescriptionList",
    method: "post",
    data: data
  });
}

/**
 * 查询审方中患者病情
 */
export function getCheckPatientRecords(data) {
  return request({
    url: "business/proCheckPrescription/getCheckPatientRecords",
    method: "post",
    data: data
  });
}

/**
 *  查询药品分类
 */
export function getDicDrugType(data) {
  return request({
    url: "basic/drugStoreType/getDrugStoreTypeList",
    method: "post",
    data: data
  });
}

/**
 *  查询是否有本次处方
 */
export function getIsPre(data) {
  return request({
    url: "business/proPrescriptionController/getIsPre",
    method: "post",
    data: data,
    headers: {
      hosId: myJsTools.getItem("hosId")
    }
  });
}

/**
 * 查询本次挂号的检验单ID
 */
export function getPlmId(data) {
  return request({
    url: "business/proLab/getPlmId",
    method: "post",
    data: data,
    headers: {
      hosId: myJsTools.getItem("hosId")
    }
  });
}

/**
 * 获取处方pdf名称
 */
export function getPrescriptionPdfName(data) {
  return request({
    url: "business/diagnosisforweb/getPrescriptionPdfName",
    method: "post",
    data: data
  });
}

/**
 * 医生端-药品销售额汇总
 */
export function getDocDrugSalesSummary(data) {
  return request({
    url: "order/webquery/getDocDrugSalesSummary",
    method: "post",
    data: data
  });
}

/**
 *  医生端-药品销售额明细
 */
export function getDocDrugSalesDetail(data) {
  return request({
    url: "order/webquery/getDocDrugSalesDetail",
    method: "post",
    data: data
  });
}

/**
 *  根据挂号id查询患者基本信息与主诉
 */
export function getPatientInfoRecordTitleByRegId(data) {
  return request({
    url: "business/patientrecords/getPatientInfoRecordTitleByRegId",
    method: "post",
    data: data
  });
}

/**
 *  根据医生id和患者id查询患者本次以及上次病情
 */
export function getNowAndLastTimeRecord(data) {
  return request({
    url: "business/patientrecords/getNowAndLastTimeRecord",
    method: "post",
    data: data
  });
}

/**
 *  查询经典处方列表
 */
export function getClassicPrescriptionList(data) {
  return request({
    url: "basic/doccommonprescription/getClassicPrescriptionList ",
    method: "post",
    data: data
  });
}

/**
 *  查询处方模板详情
 */
export function getDrugPrescriptionPreInfo(data) {
  return request({
    url: "basic/doccommonprescription/getDrugPrescriptionPreInfo",
    method: "post",
    data: data
  });
}

/**
 *  查询历史处方导入信息
 */
export function getHistoryDetailPrescriptionImportInfo(data) {
  return request({
    url:
      "business/proPrescriptionController/getHistoryDetailPrescriptionImportInfo",
    method: "post",
    data: data
  });
}

/**
 *  查询处方是否有下架药品
 */
export function getDiagPrescriptionIsNoUseDrug(data) {
  return request({
    url: "business/proPrescriptionController/getDiagPrescriptionIsNoUseDrug",
    method: "post",
    data: data
  });
}

/**
 *  根据ID获取处方业务信息(续方)
 */
export function getPrescriptionInfoByIdContinuation(data) {
  return request({
    url:
      "business/proPrescriptionController/getPrescriptionInfoByIdContinuation",
    method: "post",
    data: data
  });
}

/**
 *  医生端-处方记录
 */
export function getPrescriptionNotesByPlmId(data) {
  return request({
    url: "business/proElectronicMedicalRecord/getPrescriptionNotesByPlmId",
    method: "post",
    data: data
  });
}

/**
 *  查询医生是否支持处方池
 */
export function getDocHavePrescriptionPoolVisible(data) {
  return request({
    url: "basic/doctor/getDocHavePrescriptionPoolVisible",
    method: "post",
    data: data
  });
}

/**
 *  查询处方池信息表分页列表
 */
export function queryProPrescriptionPoolListPage(data) {
  return request({
    url: "basic/proPrescriptionPool/queryProPrescriptionPoolListPage",
    method: "post",
    data: data
  });
}

/**
 *  根据主键查询处方池列表详情
 */
export function queryProPrescriptionPoolListDetail(data) {
  return request({
    url: "basic/proPrescriptionPool/queryProPrescriptionPoolListDetail",
    method: "post",
    data: data
  });
}

/**
 *  查询处方池已接单分页列表
 */
export function queryProPrescriptionPoolReceivingListPage(data) {
  return request({
    url:
      "business/prescriptionPoolController/queryProPrescriptionPoolReceivingListPage",
    method: "post",
    data: data
  });
}
/**
 *  修改处方池订单状态
 */
export function updateProPrescriptionPoolStatus(data) {
  return request({
    url: "basic/proPrescriptionPool/updateProPrescriptionPoolStatus",
    method: "post",
    data: data
  });
}

/**
 *  根据主键查询处方池处方信息
 */
export function queryProPrescriptionPoolPrescriptionInfo(data) {
  return request({
    url: "basic/proPrescriptionPool/queryProPrescriptionPoolPrescriptionInfo",
    method: "post",
    data: data
  });
}

/**
 *  验证医生是否可以接单
 */
export function checkDocIfReceivingOrder(data) {
  return request({
    url: "basic/proPrescriptionPool/checkDocIfReceivingOrder",
    method: "post",
    data: data
  });
}

/**
 *  医生查看处方业务信息(已支付/未支付)
 */
export function getPrescriptionInfoByPayment(data) {
  return request({
    url: "business/proPrescriptionController/getPrescriptionInfoByPayment",
    method: "post",
    data: data
  });
}

/**
 *  验证扫码开方
 */
export function checkScanCodePrescription(data) {
  return request({
    url: "basic/dicDrugController/checkScanCodePrescription",
    method: "post",
    data: data
  });
}

/**
 *  获取复购确认列表
 */
export function getRepurchaseConfirmList(data) {
  return request({
    url: "business/proPrescriptionController/getRepurchaseConfirmList",
    method: "post",
    data: data
  });
}

/**
 *   复购确认接口
 */
export function updateRepurchaseConfirm(data) {
  return request({
    url: "business/proPrescriptionController/updateRepurchaseConfirm",
    method: "post",
    data: data
  });
}

/**
 *   查询复购处方是否待确认
 */
export function getPreBussIsRepurchaseWaitConfirm(data) {
  return request({
    url: "business/proPrescriptionController/getPreBussIsRepurchaseWaitConfirm",
    method: "post",
    data: data
  });
}

/**
 *   发起人脸识别
 */
export function faceRecognition(data) {
  return request({
    url: "business/faceRecognition/faceRecognition",
    method: "post",
    data: data
  });
}

/**
 *   人脸识别验证
 */
export function faceRecognitionVerify(data) {
  return request({
    url: "business/faceRecognition/faceRecognitionVerify",
    method: "post",
    data: data
  });
}

/**
 *   医生端开方前查询是否需要实名认证权限
 */
export function docBeforeThePrescriptionNeedCheckSecond(data) {
  return request({
    url: "basic/doctor/docBeforeThePrescriptionNeedCheckSecond",
    method: "post",
    data: data
  });
}

/**
 *   获取审方验证码
 */
export function getCheckCodePrescription(data) {
  return request({
    url: "business/proPrescriptionController/getCheckCodePrescription",
    method: "post",
    data: data
  });
}

/**
 *   CA审方短信校验
 */
export function checkCASignPrescription(data) {
  return request({
    url: "business/proPrescriptionController/checkCASignPrescription",
    method: "post",
    data: data
  });
}
/**
 *   获取开方验证码
 */
export function getCheckCode(data) {
  return request({
    url: "business/proPrescriptionController/getCheckCode",
    method: "post",
    data: data
  });
}
/**
 *   CA签章短信校验
 */
export function checkCASign(data) {
  return request({
    url: "business/proPrescriptionController/checkCASign",
    method: "post",
    data: data
  });
}
/**
 *   CA获取医生认证状态
 */
export function getCaAuthentication(data) {
  return request({
    url: "business/proPrescriptionController/getCaAuthentication",
    method: "post",
    data: data
  });
}
/**
 *  处方池的去沟通
 */
export function goToCommunicate(data) {
  return request({
    url: "business/proPrescriptionController/goToCommunicate",
    method: "post",
    data: data
  });
}

//根据入参查询系统字典表
export function getSysCodeByType(data) {
  return request({
    url: '/basic/syscode/getSysCodeByType',
    method: 'post',
    data: data
  })
}
// 获取当前问诊订单的问诊类型和权益卡
export function getChannelByDoctorId(data) {
  return request({
    url: '/business/proPrescriptionController/getChannelByDoctorId',
    method: 'get',
    params: data
  })
}



// 获取当前购药补方的信息
export function getSaveRedisUserDrug(data) {
  return request({
    url: '/business/proPrescriptionController/getSaveRedisUserDrug',
    method: 'get',
    params: data
  })
}

// 根据支持剂型-查询门店信息
export function getStoreByDosageform(data) {
  return request({
    url: '/basic/dicDrugController/getStoreByDosageform',
    method: 'get',
    params: data
  })
}

// 医生问诊中的视频订单
export function getTcmVideoOrder(data) {
  return request({
    url: '/business/proregister/getTcmVideo',
    method: 'get',
    params: data
    })
}

// 更新处方支付前是否可见
export function updatePrescriptionBeforePayVisible(data) {
  return request({
    url: '/business/proPrescriptionController/updatePrescriptionBeforePayVisible',
    method: 'get',
    params: data
    })
}

// 处方模板列表
export function prescriptionTemplateList(data) {
  return request({
    url: '/basic/prescription/template/list',
    method: 'post',
    data
  })
}

// 新增处方模板
export function prescriptionTemplateAdd(data) {
  return request({
    url: '/basic/prescription/template/add',
    method: 'post',
    data,
    loading: true
  })
}

// 处方模板修改
export function prescriptionTemplateUpdate(data) {
  return request({
    url: '/basic/prescription/template/update',
    method: 'post',
    data,
    loading: true
  })
}

// 处方模板删除
export function prescriptionTemplateDelete(data) {
  return request({
    url: '/basic/prescription/template/delete',
    method: 'post',
    data,
    loading: true
  })
}

// 导入处方模板
export function prescriptionTemplateImport(data) {
  return request({
    url: '/basic/prescription/template/import',
    method: 'post',
    data,
    loading: true,
  })
}

// 导入处方模板V2
export function prescriptionTemplateImportNew(data) {
  return request({
    url: '/basic/prescription/template/importNew',
    method: 'post',
    data,
    loading: true,
  })
}

// 导入处方模板新V2
export function prescriptionTemplateImportNewV2(data) {
  return request({
    url: '/basic/prescription/template/importNewV2',
    method: 'post',
    data,
    loading: true,
  })
}

// 查询导入的药品信息
export function queryDrugByDrugIds(data) {
  return request({
    url: '/basic/dicDrugController/queryDrugByDrugIds',
    method: 'post',
    data,
    loading: true,
  })
}

// 根据药品名查询药店的药品信息
export function queryDrugByDrugNames(data) {
  return request({
    url: '/basic/dicDrugController/queryDrugByDrugNames',
    method: 'post',
    data,
    loading: true,
  })
}

// 根据药品ID查询标准库中药店的药品信息
export function changeStoreQueryDrugList(data) {
  return request({
    url: '/basic/dicDrugController/changeStoreQueryDrugList',
    method: 'post',
    data,
    loading: true,
  })
}

// 处方模板详情
export function prescriptionTemplateDetail(data) {
  return request({
    url: '/basic/prescription/template/detail',
    method: 'post',
    data
  })
}
/**
 * 保存埋点信息，会返回id，用于提交处方后的接口使用
 */
export function trackingPointSave(data) {
  return request({
    url: "business/trackingPoint/save",
    method: "post",
    data: data,
    ignoreError: true
  });
}

/**
 * 开方后调用此接口，携带id和处方id
 */
export function trackingPointUpdate(data) {
  return request({
    url: "business/trackingPoint/update",
    method: "post",
    data: data,
    ignoreError: true
  });
}

/**
 * 查询价格明细
 */
export function queryPriceDetail(data) {
  return request({
    url: "basic/calcPrice/queryPriceDetail",
    method: "post",
    data: data,
  });
}

/**
 * 电子病历数据回显
 */
export function queryElectronicMedicalByRegId(data) {
  return request({
    url: "business/proElectronicMedicalRecord/queryElectronicMedicalByRegId",
    method: "post",
    data: data,
  });
}

/**
 * 保存或更新电子病历
 */
export function saveOrUpdateProElectronicMedical(data) {
  return request({
    url: "business/proElectronicMedicalRecord/saveOrUpdateProElectronicMedical",
    method: "post",
    data: data,
    loading: true
  });
}

/**
 * 暂存电子病历（草稿）
 */
export function saveElectronicMedicalRecordDraft(data) {
  return request({
    url: "business/proElectronicMedicalRecord/saveElectronicMedicalRecordDraft",
    method: "post",
    data: data,
    ignoreError: true
  });
}

/**
 * 查询电子病历明细
 */
export function queryElectronicMedicalDetail(data) {
  return request({
    url: "business/proElectronicMedicalRecord/queryElectronicMedicalDetail",
    method: "post",
    data: data,
  });
}

/**
 * 根据患者id查询患者档案
 */
export function queryPatientRecordByPatientId(data) {
  return request({
    url: "business/patientRecord/queryPatientRecordByPatientId",
    method: "post",
    data: data,
  });
}

/**
 * 根据患者查询电子病历历史分页
 */
export function getElecMedicalByPatientPage(data) {
  return request({
    url: "business/proElectronicMedicalRecord/getElecMedicalByPatientPage",
    method: "post",
    data: data,
  });
}

/**
 * 根据患者查询患者处方记录
 */
export function getWebPrescriptionServiceNotes(data) {
  return request({
    url: "business/proElectronicMedicalRecord/getWebPrescriptionServiceNotes",
    method: "post",
    data: data,
  });
}

/**
 * 指定剂型供应链 查询默认药店
 */
export function getDefaultDrugstore(data) {
  return request({
    url: "basic/dicDrugController/getDefaultDrugstore",
    method: "post",
    data: data,
  });
}

/**
 * 指定剂型供应链 获取药店列表，饮片类型默认第一个就是推荐的
 */
export function getDrugstoreList(data) {
  return request({
    url: "basic/dicDrugController/getDrugstoreList",
    method: "post",
    data: data,
  });
}

/**
 * 指定剂型供应链 获取药店列表，饮片类型默认第一个就是推荐的V2版本，后端内部逻辑改变，入参调整
 */
export function getDrugstoreListV2(data) {
  return request({
    url: "basic/dicDrugController/getDrugstoreListV2",
    method: "post",
    data: data,
  });
}

/**
 * 获取西药药店列表
 */
export function queryDrugStorePageList(data) {
  return request({
    url: "basic/dicDrugController/queryDrugStorePageList",
    method: "post",
    data: data,
  });
}

// 获取病情列表
export function getconditionList(data) {
  return request({
    url: "basic/patient-file/patientFileList",
    method: "post",
    data: data,
  });
}
// 获取病情列表
export function queryTypeTree(data = {}) {
  return request({
    url: "basic/patient-file/queryTypeTree",
    method: "get",
    data: data,
  });
}

// 新增病情
export function addPatientFile(data) {
  return request({
    url: "basic/patient-file/addPatientFile",
    method: "post",
    data: data,
  });
}
// 编辑病情
export function editPatientFile(data) {
  return request({
    url: "basic/patient-file/editPatientFile",
    method: "post",
    data: data,
  });
}
// 删除病情
export function deletePatientFile(data) {
  return request({
    url: "basic/patient-file/deletePatientFile",
    method: "post",
    data: data,
  });
}

export function rationalDrugCheck(data) {
  return request({
    url: 'business/rationalDrugCheck/check',
    method: 'post',
    data
  })
}
// 获取医生三要素信息及实名状态
export function getRealNameAuthInfo(data={}) {
  return request({
    url: "basic/doctor/auth/findSimpleDoctorInfoByID",
    method: "post",
    loading: true,
    data: data,
  });
}
// 获取放心签人脸识别地址
export function getFaceRecognitionUrl(data={}) {
  return request({
    url: "basic/doctor/auth/getFaceVolcengineUrl",
    method: "post",
    data: data,
  });
}
// 手机号认证--发送验证码
export function sendVerifyCode(data={}) {
  return request({
    url: "basic/doctor/auth/sendVcode",
    method: "post",
    data: data,
  });
}
// 手机号验证
export function verifyPhone(data={}) {
  return request({
    url: "basic/doctor/auth/authByPhoneSmsVcode",
    method: "post",
    data: data,
  });
}
// 查询认证结果
export function getAuthResult(data={}) {
  return request({
    url: "basic/doctor/auth/getFaceVolcengineResult",
    method: "post",
    data: data,
  });
}

// 获取CA协议url
export function getCaAgreementUrl(data={}) {
  return request({
    url: "basic/doctor/auth/caAgreement/apply",
    method: "post",
    data: data,
  });
}